"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detachSyntheticRecords = exports.removeRawMasterLoanTapeToMasterLoanTapeDependencies = exports.createBorrowingBaseReports = exports.createGeneratedLoanTapeToReceivableResponseTapeDependencies = exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape = exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes = exports.createGeneratedCashBalanceFeedToBorrowingBaseReportDependencies = void 0;
const lodash_1 = __importDefault(require("lodash"));
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const typeguards_1 = require("../typeguards");
const assetVerification = __importStar(require("./assetVerification"));
const syntheticCovenantLoanTape = __importStar(require("./covenantLoanTape"));
const lenderApprovalFlow = __importStar(require("./lenderApprovalFlow"));
const syntheticMasterLoanTape = __importStar(require("./masterLoanTape"));
const mesh = __importStar(require("./mesh"));
const repaymentTape = __importStar(require("./repaymentTape"));
const utils = __importStar(require("./utils"));
const { cloneDeep, includes, remove } = lodash_1.default;
const createGeneratedCashBalanceFeedToBorrowingBaseReportDependencies = ({ generatedCashBalanceFeeds, borrowingBaseReports, }) => (0, remeda_1.map)(generatedCashBalanceFeeds, (generatedCashBalanceFeed) => {
    const { creditFacilitySlug } = generatedCashBalanceFeed;
    (0, common_1.finleyAssert)(creditFacilitySlug, 'creditFacilitySlug must exist on generatedCashBalanceFeed');
    const filteredBorrowingBaseReports = (0, remeda_1.filter)(borrowingBaseReports, (report) => report.creditFacilitySlug === creditFacilitySlug);
    (0, common_1.finleyAssert)(filteredBorrowingBaseReports.length === 1, `unable to find single borrowing base report with creditFacilitySlug ${creditFacilitySlug}`);
    const borrowingBaseReport = filteredBorrowingBaseReports[0];
    return {
        outputArtifactId: borrowingBaseReport.id,
        inputArtifactId: generatedCashBalanceFeed.id,
    };
});
exports.createGeneratedCashBalanceFeedToBorrowingBaseReportDependencies = createGeneratedCashBalanceFeedToBorrowingBaseReportDependencies;
const createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes = ({ creditFacilitySlugs, dataTapes, cfToLpMap, }) => {
    const receivableResponseTapes = (0, remeda_1.filter)(dataTapes, (tape) => tape.type === 'receivableResponseTape' &&
        !!tape.creditFacilitySlug &&
        includes(creditFacilitySlugs, tape.creditFacilitySlug));
    const generatedLoanTapes = utils.filterGeneratedLoanTapes({ dataTapes });
    (0, common_1.finleyAssert)(receivableResponseTapes.length === creditFacilitySlugs.length, 'receivableResponseTapes must map 1:1 to creditFacilitySlugs');
    const cfSlugToReceivableResponseTapeMap = (0, remeda_1.indexBy)(receivableResponseTapes, ({ creditFacilitySlug }) => creditFacilitySlug);
    return (0, remeda_1.pipe)(creditFacilitySlugs, (0, remeda_1.flatMap)((cfSlug) => {
        const lpSlugs = cfToLpMap[cfSlug];
        (0, common_1.finleyAssert)(lpSlugs, `lpSlugs must be defined for creditFacilitySlug ${cfSlug}`);
        const outputArtifact = cfSlugToReceivableResponseTapeMap[cfSlug];
        (0, common_1.finleyAssert)(outputArtifact, `receivable response tape must exist in cfSlugToReceivableResponseTapeMap for ${cfSlug}`);
        const { id: outputArtifactId } = outputArtifact;
        const inputArtifacts = (0, remeda_1.filter)(generatedLoanTapes, (tape) => includes(lpSlugs, tape.loanProductSlug));
        return (0, remeda_1.map)(inputArtifacts, ({ id: inputArtifactId }) => ({
            inputArtifactId,
            outputArtifactId,
        }));
    }));
};
exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes = createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes;
const createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape = ({ creditFacilitySlugs, dataTapes, }) => {
    const dependencies = [];
    const masterLoanTapes = (0, remeda_1.filter)(dataTapes, (tape) => tape.type === 'masterLoanTape' &&
        !!tape.creditFacilitySlug &&
        creditFacilitySlugs.includes(tape.creditFacilitySlug));
    (0, remeda_1.forEach)(masterLoanTapes, (masterLoanTape) => {
        const { configuration, artifactSlug: masterLoanTapeArtifactSlug, } = masterLoanTape;
        (0, common_1.finleyAssert)(typeguards_1.typeguards.isTapeBuilderMasterLoanTapeConfiguration(configuration), `masterLoanTape ${masterLoanTapeArtifactSlug} configuration is invalid`);
        const { generatedMasterLoanTapeArtifactSlug } = configuration;
        const generatedMasterLoanTape = utils.findArtifactBySlug({
            artifactSlug: generatedMasterLoanTapeArtifactSlug,
            dataTapes,
        });
        const { creditFacilitySlug } = generatedMasterLoanTape;
        (0, common_1.finleyAssert)(creditFacilitySlug, `creditFacilitySlug must be defined for preassignedLoanTape generatedLoanTape ${generatedMasterLoanTapeArtifactSlug}`);
        const receivableResponseResponseTapes = (0, remeda_1.filter)(dataTapes, (tape) => tape.type === 'receivableResponseTape' &&
            tape.creditFacilitySlug === creditFacilitySlug);
        (0, common_1.finleyAssert)(receivableResponseResponseTapes.length === 1, `receivableResponseTape must be unique per creditFacilitySlug ${creditFacilitySlug}`);
        const receivableResponseTape = receivableResponseResponseTapes[0];
        dependencies.push({
            outputArtifactId: receivableResponseTape.id,
            inputArtifactId: generatedMasterLoanTape.id,
        });
    });
    return dependencies;
};
exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape = createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape;
const createGeneratedLoanTapeToReceivableResponseTapeDependencies = ({ cfToLpMap, loanTapeTypeMap, dataTapes, }) => {
    const dependencies = [];
    const lpCfSlugGroupings = mesh.createLpCfSlugGroupings(cfToLpMap);
    const lpCfSlugGroupingsWithTypes = mesh.attachLoanTapeTypes({
        loanTapeTypeMap,
        lpCfSlugGroupings,
    });
    let deps = [];
    (0, remeda_1.forEach)(lpCfSlugGroupingsWithTypes, ({ creditFacilitySlugs, loanTapeType }) => {
        switch (loanTapeType) {
            // for master loan tape archetypes, there is only every 1 master loan tape artifact
            // per loan product, as such we can safely use cfToLpMap to reconstruct edges.
            // as there is a break in the graph for master loan tape type, we cannot explicitly reconstruct edges
            case 'preassignedMasterLoanTape':
            case 'masterLoanTape': {
                deps = (0, exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForMasterLoanTapeArchetypes)({
                    creditFacilitySlugs,
                    cfToLpMap,
                    dataTapes,
                });
                break;
            }
            // for preassigned loan tape, there may be multiple master loan tape (generated loan tape) artifact
            // per loan product, we need to explicitly re-construct the edges
            case 'preassignedLoanTape': {
                deps = (0, exports.createGeneratedLoanTapeToReceivableResponseTapeDependenciesForPreassignedLoanTape)({
                    creditFacilitySlugs,
                    dataTapes,
                });
                break;
            }
            default:
                (0, common_1.finleyAssertUnreachable)(loanTapeType);
        }
        deps.forEach((dep) => dependencies.push(dep));
    });
    return dependencies;
};
exports.createGeneratedLoanTapeToReceivableResponseTapeDependencies = createGeneratedLoanTapeToReceivableResponseTapeDependencies;
const createBorrowingBaseReports = (dataTapes) => (0, remeda_1.map)(dataTapes, (tape) => {
    return {
        ...tape,
        type: 'borrowingBaseReport',
        creditFacilitySlug: null,
        configuration: (0, remeda_1.omit)(tape.configuration, [
            'receivableResponseTapeArtifactSlug',
            'cashBalancesFeedContextArtifactSlug',
            'repaymentTapeArtifactSlugs',
            'cashResponseTapeArtifactSlug',
        ]),
    };
});
exports.createBorrowingBaseReports = createBorrowingBaseReports;
const removeRawMasterLoanTapeToMasterLoanTapeDependencies = ({ dbGraph, masterLoanTapes, }) => {
    const { dataTapes, dataTapeDependencies } = dbGraph;
    const rawMasterLoanTapeToMasterLoanTapeDependencies = (0, remeda_1.map)(masterLoanTapes, (masterLoanTape) => {
        const { rawMasterLoanTapeArtifactSlug } = masterLoanTape.configuration;
        (0, common_1.finleyAssert)(rawMasterLoanTapeArtifactSlug, 'rawMasterLoanTapeArtifactSlug must exist in masterLoanTape');
        const rawMasterLoanTape = utils.findArtifactBySlug({
            artifactSlug: rawMasterLoanTapeArtifactSlug,
            dataTapes,
        });
        return utils.getDependency({
            outputArtifactId: masterLoanTape.id,
            inputArtifactId: rawMasterLoanTape.id,
            dataTapeDependencies,
        });
    });
    return utils.removeDependencies({
        dataTapeDependencies,
        dependenciesToRemove: rawMasterLoanTapeToMasterLoanTapeDependencies,
    });
};
exports.removeRawMasterLoanTapeToMasterLoanTapeDependencies = removeRawMasterLoanTapeToMasterLoanTapeDependencies;
/**
 * Unwinds all the changes listed attach.ts
 */
const detachSyntheticRecords = (dbGraphOriginal) => {
    // undo changes in the reverse order as attach.ts
    const dbGraph = (0, remeda_1.pipe)(dbGraphOriginal, assetVerification.removeAssetVerificationArtifacts, lenderApprovalFlow.removeLenderApprovalArtifacts);
    const { dataTapeDependencies } = dbGraph;
    const dataTapes = cloneDeep(dbGraph.dataTapes);
    const loanTapeTypeMap = utils.generateLoanTapeTypeMap(dataTapes);
    // get tapes
    const generatedCovenantLoanTapes = utils.filterGeneratedCovenantLoanTapes({
        dataTapes,
    });
    const generatedLoanTapes = utils.filterGeneratedLoanTapes({ dataTapes });
    const generatedCashBalanceFeeds = utils.filterGeneratedCashBalanceFeeds({
        dataTapes,
    });
    const manualBankAccountReports = utils.filterManualBankAccountReports({
        dataTapes,
    });
    const cashResponseTapes = utils.filterCashResponseTapes({
        dataTapes,
    });
    const cashBalancesFeedContexts = utils.filterCashBalancesFeedContexts({
        dataTapes,
    });
    const masterLoanTapes = utils.filterMasterLoanTapes({ dataTapes });
    const assignedLoanTapes = utils.filterAssignedLoanTapes({ dataTapes });
    const receivableResponseTapePreviews = utils.filterReceivableResponseTapePreviews({ dataTapes });
    const receivableResponseTapes = utils.filterReceivableResponseTapes({
        dataTapes,
    });
    const borrowingBaseReports = utils.filterBorrowingBaseReports({
        dataTapes,
    });
    // snapshot the cfToLpMap prior to removing dependencies
    const cfToLpMap = mesh.createCfToLpMap({
        outputArtifacts: receivableResponseTapes,
        inputArtifacts: assignedLoanTapes,
        dataTapeDependencies,
    });
    // nullify any intermediate tapes that are used as rawMasterLoanTape
    // and have cfSlug and lpSlug configured
    (0, remeda_1.forEach)(generatedLoanTapes, (generatedLoanTape) => {
        const rawMasterLoanTapeArtifactSlug = syntheticMasterLoanTape.parseRawMasterLoanTapeArtifactSlug({
            generatedLoanTape,
            dataTapes,
        });
        const configuredRawMasterLoanTapeArtifact = utils.findArtifactBySlug({
            artifactSlug: rawMasterLoanTapeArtifactSlug,
            dataTapes,
        });
        if (configuredRawMasterLoanTapeArtifact.type !== 'rawLoanTape') {
            const removedTapes = remove(dataTapes, (tape) => tape.artifactSlug === rawMasterLoanTapeArtifactSlug);
            (0, common_1.finleyAssert)(removedTapes.length === 1, 'unable to remove configuredRawMasterLoanTapeArtifact');
            const updatedTape = {
                ...removedTapes[0],
                creditFacilitySlug: null,
                loanProductSlug: null,
            };
            dataTapes.push(updatedTape);
        }
    });
    // remove the rawMasterLoanTape<>masterLoanTape dependencies
    const dependenciesWithoutRawMasterToMasterDependency = (0, exports.removeRawMasterLoanTapeToMasterLoanTapeDependencies)({ dbGraph: { dataTapeDependencies, dataTapes }, masterLoanTapes });
    // remove unnecessary dependencies by inputArtifactId
    let tempDependencies = utils.removeDependenciesByInputArtifactId({
        dataTapeDependencies: dependenciesWithoutRawMasterToMasterDependency,
        inputArtifactIds: (0, remeda_1.flatMap)([
            generatedLoanTapes,
            masterLoanTapes,
            receivableResponseTapePreviews,
            assignedLoanTapes,
            cashResponseTapes,
            cashBalancesFeedContexts,
            manualBankAccountReports,
            generatedCashBalanceFeeds,
        ], (tapes) => (0, remeda_1.map)(tapes, (tape) => tape.id)),
    });
    // remove unnecessary dependencies by outputArtifactId
    tempDependencies = utils.removeDependenciesByOutputArtifactId({
        dataTapeDependencies: tempDependencies,
        outputArtifactIds: (0, remeda_1.flatMap)([cashResponseTapes], (tapes) => (0, remeda_1.map)(tapes, (tape) => tape.id)),
    });
    // remove synthetic nodes
    const tempDataTapes = utils.removeArtifactsByTypes({
        dataTapes,
        types: [
            'masterLoanTape',
            'receivableResponseTapePreview',
            'assignedLoanTape',
            'borrowingBaseReport',
            'manualBankAccountReport',
            // TODO this cannot use cashResponseTape.removeCashResponseTapeArtifacts since all cashBalancesFeedContext dataTapes are removed before it is called
            // update cashBalancesFeedContext to include a cashBalancesFeedContext.removeCashBalancesFeedContextArtifacts method then remove from here and
            // tempDependencies above https://linear.app/finleycms/issue/ENG-3079/update-cashbalancesfeedcontext-to-have-a-detach-method
            'cashResponseTape',
            'cashBalancesFeedContext',
        ],
    });
    // re-create original edges for UI
    const generatedLoanTapeToBorrowingBaseReportDeps = (0, exports.createGeneratedCashBalanceFeedToBorrowingBaseReportDependencies)({
        generatedCashBalanceFeeds,
        borrowingBaseReports,
    });
    // re-create original edges for UI
    const generatedLoanTapeToReceivableResponseTapeDeps = (0, exports.createGeneratedLoanTapeToReceivableResponseTapeDependencies)({
        cfToLpMap,
        loanTapeTypeMap,
        dataTapes,
    });
    const generatedCovenantLoanTapeDeps = syntheticCovenantLoanTape.createGeneratedLoanTapeToGeneratedCovenantLoanTapeDependencies({
        generatedCovenantLoanTapes,
        generatedLoanTapes,
        loanTapeTypeMap,
    });
    // re-create original borrowingBaseReports
    const originalBorrowingBaseReports = (0, exports.createBorrowingBaseReports)(borrowingBaseReports);
    const preVerificationGraph = {
        dataTapes: [...tempDataTapes, ...originalBorrowingBaseReports],
        dataTapeDependencies: [
            ...tempDependencies,
            ...generatedLoanTapeToBorrowingBaseReportDeps,
            ...generatedLoanTapeToReceivableResponseTapeDeps,
            ...generatedCovenantLoanTapeDeps,
        ],
    };
    const finalDbGraph = (0, remeda_1.pipe)(preVerificationGraph, repaymentTape.removeInternalRepaymentTapeArtifacts);
    for (const finalDataTape of finalDbGraph.dataTapes) {
        (0, common_1.finleyAssert)(typeguards_1.typeguards.isTapeBuilderRecordUI(common_1.utils.stripDbTimeStamps(finalDataTape)), new common_1.error.FinleyError(`[${finalDataTape.id}] is invalid tapeBuilder UI record while detaching synthetic`, {
            metadata: {
                logMeta: {
                    errorTape: JSON.stringify(finalDataTape),
                },
            },
        }));
    }
    return finalDbGraph;
};
exports.detachSyntheticRecords = detachSyntheticRecords;
//# sourceMappingURL=detach.js.map